import React, { useEffect, useRef } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useFormContext } from "react-hook-form";
import { CircularProgress } from "@mui/material";

function WebsiteGoals(props) {
  const { nextStep, prevStep, handleSubmit, isSubmitting ,submitted,errorMessage} = props;

  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();




  return (
    <>
      <div className="w-full space-y-5">
        <div className="space-y-5">
          <div className="space-y-8 mt-4">
            <div>
              <label className="text-lg text-gray-500">Brand Voice and Tone</label>

              <input
                type="text"
                name="brand_voice_and_tone "
                placeholder="e.g. formal/informal, friendly/corporate, fun/serious"
                className="outline-none border-b w-full py-2 text-sm"
                {...register("brand_voice_and_tone")}
              />

            </div>
            <div>
              <label className="text-lg text-gray-500">Preferred design style</label>

              <input
                type="text"
                name="preferred_design_style"
                placeholder="e.g. modern, minimalist, classic "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("preferred_design_style")}
              />

            </div>
            <div>
              <label className="text-lg text-gray-500">Color preferences </label>

              <input
                type="text"
                name="color_preferences"
                placeholder="Write color preferences"
                className="outline-none border-b w-full py-2 text-sm"
                {...register("color_preferences")}
              />

            </div>
            <div>
              <label className="text-lg text-gray-500">Links to websites or design elements that inspire you  </label>

              <input
                type="text"
                name="example_website"
                placeholder="Links to websites or design elements that inspire you "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("example_website")}
              />

            </div>
            {/* <div>
              <label className="text-lg text-gray-500">Business logo or any other pictures to be included  </label>

              <input
                type="file"
                name="business_logo"
                placeholder="Business logo or any other pictures to be included  "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("business_logo")}
              />
            
            </div> */}
            <div>
              <label className="text-lg text-gray-500">Any other requirements   </label>
              <input
                type="text"
                name="other_requirements"
                placeholder="Any other requirements "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("other_requirements")}
              />

            </div>


          </div>
        </div>
       {errorMessage && <div className="text-sm text-red-600 "><p>Failed to submit the form. Please try again.</p></div>}

        <div className="flex justify-between items-center">
          <button className="p-0 text-gray-500" onClick={() => {
            prevStep();
                 if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
          }}
            disabled={isSubmitting || submitted}

          ><FaArrowLeftLong /></button>
          <button
            className=" bg-[#FFC067] text-dark font-bold  rounded px-6 py-3 text-base md:text-lg hover:bg-[#DF73FF]  transition ease-in duration-300 cursor-pointer "
            onClick={handleSubmit}
            type="submit"
            disabled={isSubmitting || submitted}
          >
            {submitted? "Submittted" : isSubmitting ? <div className="flex space-x-1"> <CircularProgress color="dark" size='20px' className="mt-1" /> <p>Submitting...</p>  </div> : "Submit"}

          </button>
        </div>
      </div>
    </>
  );
}

export default WebsiteGoals;
